import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../";

const initialState: { unreadCount: number | undefined } = { unreadCount: undefined };

export const updateUnreadCount = createAction<{ unreadCount: number | undefined }>(
  "unreadCount/update",
);

export const intercomReducer = createReducer(initialState, (builder) => {
  builder.addCase(updateUnreadCount, (state, action) => {
    state.unreadCount = action.payload.unreadCount;
  });
});

export const selectUnreadCount = createSelector(
  (state: RootState) => state,
  (state) => state.intercom.unreadCount,
);
